import en from '../locales/translation-countries-en.json';

export default function getCountryCode(country: string) {
    const entry = Object.entries(en).find(([ k, v ]) => v === country);
    return entry?.[0];
}
